import * as React from "react";
import type { SVGProps } from "react";
const SvgIcBadgeFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#ic_badge_filled_svg__a)">
      <path
        fill="#0084FF"
        d="M1.488 5.294a3.203 3.203 0 0 1 2.233-3.768 3.2 3.2 0 0 1 1.59-.05 3.2 3.2 0 0 1 5.39 0 3.197 3.197 0 0 1 3.775 2.233c.15.518.167 1.066.048 1.593a3.2 3.2 0 0 1 0 5.394 3.204 3.204 0 0 1-2.225 3.773 3.2 3.2 0 0 1-1.59.052 3.2 3.2 0 0 1-5.398 0 3.197 3.197 0 0 1-3.823-3.817 3.2 3.2 0 0 1 0-5.41"
      />
      <path
        stroke="#FAFAFA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="m5.6 8.04 1.6 1.6 3.202-3.201"
      />
    </g>
    <defs>
      <clipPath id="ic_badge_filled_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIcBadgeFilled;
